import { useAtomValue } from 'jotai';
import pdpIsEditOrderSuccessAtom from './pdpIsEditOrderSuccessAtom';
const usePdpIsEditOrderSuccess = () => {
  const pdpIsEditOrderSuccess = useAtomValue(pdpIsEditOrderSuccessAtom);
  return pdpIsEditOrderSuccess;
};
export default usePdpIsEditOrderSuccess;